var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChartPurple = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.678 8.3H0v5.28h2.678V8.3ZM7.559 0H4.88v13.58h2.678V0ZM12.44 4.615H9.762v8.964h2.678V4.615ZM17.302 2.583h-2.678v10.996h2.678V2.583ZM17.302 15.365H0v2.678h17.302v-2.678Z",
  fill: "#662D91"
})));
export { SvgChartPurple as ReactComponent };
export default __webpack_public_path__ + "4f7d042a4abf28fdf471eb2e306e6db1.svg";